import ROUTES from "../shared/constants/routes";

import LoginComponent from "../components/LoginComponent/LoginComponent";
import NoAccessComponent from "../components/NoAccessComponent/NoAccessComponent";
import UserManagement from "../components/UserManagementComponent/UserManagement";
import ConfigurePlant from "../components/ConfigurePlantsComponent/ConfigurePlant";
import QuestionManagement from "../components/QuestionManagementComponent/QuestionManagement";
import ScoringManagementComponent from "../components/ScoringManagementComponent/ScoringManagementComponent";

/*
* define routes
* */
const routes = [
  {
    path: ROUTES.LANDING,
    exact: true,
    isPrivateRoute: false,
    component: LoginComponent
  },
  {
    path: ROUTES.NO_ACCESS,
    exact: true,
    isPrivateRoute: false,
    component: NoAccessComponent
  },
  {
    path: ROUTES.DASHBOARD,
    exact: true,
    isPrivateRoute: true,
    component: UserManagement
  },
  {
    path: ROUTES.QUESTIONMANAGEMENT,
    exact: true,
    isPrivateRoute: true,
    component: QuestionManagement
  },
  {
    path: ROUTES.PLANTMANAGEMENT,
    exact: true,
    isPrivateRoute: true,
    component: ConfigurePlant
  },
  {
    path: ROUTES.SCORINGMANAGEMENT,
    exact: true,
    isPrivateRoute: true,
    component: ScoringManagementComponent
  }
];

export default routes;